l<template>
  <v-snackbar
    v-model="SnackbarComponent.SnackbarVmodel"
    :color="SnackbarComponent.SnackbarColor"
    :timeout="3000"
    location="top"
  >
    <div class="text-center font-weight-bold">
      {{ SnackbarComponent.SnackbarMessage }}
    </div>
  </v-snackbar>
</template>

<script>
export default {
  props: { SnackbarComponent: Object },
};
</script>
